export default "__VITE_ASSET__DMndP2sr__"